<!--
 * @Description: 选择提现人员弹框组件
 * @Author: gaohc
 * @Date: 2023-10-18 18:43:52
 * @LastEditTime: 2023-12-08 16:35:16
-->
<template>
  <div class="sel-docnurse--dlg-body">
    <el-dialog width="556px" title="选择人员" :visible.sync="visible" :close-on-click-modal="false"
      :before-close="handleCancel" center>
      <div class="docnurse-list">
        <div class="item"  v-for="(item, index) in attendantList" :key="index"
          @click="handleSelectDocnurse(item)"
          :class="{'select-item' : selectId == item.id}">
          <div>
            <span class="docnurse-name">
              {{item.name}}
            </span>
            <span>{{item.mobile}}</span>
          </div>
          <i class="el-icon-check" style="color: #3E7EF5;font-size: 18px;"
            v-if="selectId == item.id"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SelDocnurse',
  props: ['visible', "attendantList"],

  data() {
    return {
      selectId: null
    }
  },
  
  methods: {
    handleSelectDocnurse(item) {
      this.selectId = item.id;
      this.$emit("hanle-select", item.id)
    },

    //取消
    handleCancel() {
      this.$emit('close-dialog', {refresh: false});
    }
  },
}
</script>

<style>
.sel-docnurse--dlg-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.sel-docnurse--dlg-body .docnurse-list {
  font-size: 14px;
  color: #3D3D3D;
  min-height: 200px;
}
.sel-docnurse--dlg-body .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 30px 0 90px;
}
.sel-docnurse--dlg-body .el-dialog__body {
    padding: 10px 0 10px 0;
}
.sel-docnurse--dlg-body .docnurse-name {
  min-width: 190px;
  display: inline-block;
  padding-right: 5px;
}
.sel-docnurse--dlg-body .select-item {
  background: #F5F8FF;
  color: #3E7EF5;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/settlementacctlist/SelDocnurse.vue